module.exports = __webpack_public_path__ + "media/images/empresa/emp_sucursal-74404655f5066ab0ca1de777a0e78501.svg";